// Tagify autocomplete fields
import Tagify from '@yaireo/tagify';
import Bloodhound from 'bloodhound-js';
import { APPLICATION_CAR, APPLICATION_RESIDENTIAL, APPLICATION_STOCK_FINANCE, APPLICATION_SUPPLIER_ACCREDITATION } from './constants';

window.Swal = require('sweetalert2');

// Restricts input for each element in the set of matched elements to the given inputFilter.
(function ($) {
  $.fn.inputFilter = function (inputFilter) {
    return this.on(
      'input keydown keyup mousedown mouseup select contextmenu drop',
      function() {
        if (inputFilter(this.value)) {
          this.oldValue = this.value;
          this.oldSelectionStart = this.selectionStart;
          this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty('oldValue')) {
          this.value = this.oldValue;
          this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        }
      }
    );
  };
})(jQuery);

window.normalizeTaggedValue = value => {
  if (typeof value !== 'string') {
    return '';
  }

  const valueMatch = value.match(/value":"([^"]+)"/)
  return valueMatch ? valueMatch[1] : value
}

const tagify = {};

// Tagify fields for auto completing solar module and inverter model numbers
window.initProductAutocompletion = (productTypeEl) => {
  const input = $(productTypeEl)
    .closest('tr')
    .find('input.js-product-model-input');
  const identifier = $(productTypeEl).attr('id');

  // for partial mode, there is no input for product name
  if (!input.length) {
    return
  }

  // Destroy tagify element if exists
  if (typeof tagify[identifier] !== 'undefined') {
    tagify[identifier].destroy();
    delete tagify[identifier];
  }

  let url;
  switch (parseInt($(productTypeEl).val())) {
    case 1: // solar panels
      url = '/data/solar-modules.json';
      break;
    case 2: // solar inverters
      url = '/data/solar-inverters.json';
      break;
    default:
      // If the field's not a solar panel or inverter, change it back to normal input
      input.addClass('form-control');
      input.val(normalizeTaggedValue(input.val()));
      return;
  }

  // Is this already a tagify field?
  if (typeof tagify[identifier] !== 'undefined') {
    return;
  }

  let controller;
  // Small delay to ensure DOM is ready
  setTimeout(() => {
    tagify[identifier] = new Tagify(input[0], {
      mode: 'select',
      whitelist: [],
      readonly: false,
      maxTags: 1,
      dropdown: {
        maxItems: 50
      }
    });

    // listen to any keystrokes which modify tagify's input
    tagify[identifier].on('input', onInput);

    function onInput(e) {
      const { value } = e.detail;
      tagify[identifier].settings.whitelist.length = 0; // reset the whitelist
      tagify[identifier].settings.readonly = true;

      // https://developer.mozilla.org/en-US/docs/Web/API/AbortController/abort
      controller && controller.abort();
      controller = new AbortController();

      fetch(`${url}?q=${value}`, {
        signal: controller.signal
      })
        .then(RES => RES.json())
        .then(whitelist => {
          tagify[identifier].settings.whitelist = whitelist;
          tagify[identifier].dropdown.show.call(
            tagify[identifier],
            value.split(' ')[0]
          );
        });
    }
  }, 0);
};
$(document).on('change', '.js-product-type-select', function () {
  initProductAutocompletion(this);
});

window.sfDocumentReady([], () => {
  // Restrict input to ABN numbers.
  $('.js-restrict-input-abn').inputFilter(value => {
    if (!/^[0-9\s-]*$/.test(value)) {
      return false;
    }
    return /^\d{0,11}$/.test(value.replace(/[^0-9]/g, ''));
  });

  // Restrict input to ACN numbers.
  $('.js-restrict-input-acn').inputFilter(value => {
    if (!/^[0-9\s-]*$/.test(value)) {
      return false;
    }
    return /^\d{0,9}$/.test(value.replace(/[^0-9]/g, ''));
  });

  // Restrict input to phone numbers.
  $('.js-restrict-input-phone-number').inputFilter(value =>
    /^[0-9()+\s-]*$/.test(value.replace(/[^0-9]/g, ''))
  );

  // Restrict input to Australian phone numbers.
  $('.js-restrict-input-australia-phone-number').inputFilter(value => {
    if (!/^[0-9()+\s-]*$/.test(value)) {
      return false;
    }
    return /^(61|0)\d{0,9}$/.test(value.replace(/[^0-9]/g, ''));
  });

  // Restrict input to positive integer digits by using a regular expression filter.
  $('.js-positive-integers-only').inputFilter(value =>
    /^([1-9]\d*)?$/.test(value)
  );

  // Restrict input to numeric digits by using a regular expression filter.
  $('.js-positive-numeric-only').inputFilter(value =>
    /^([0-9]\d*)?$/.test(value)
  );

  // Restrict input to positive integer or zero digits by using a regular expression filter.
  $('.js-positive-integers-only').inputFilter(value => /^\d*$/.test(value));

  // Restrict input to numeric values (max 2 decimal places) by using a regular expression filter.
  $('.js-positive-currency-only').inputFilter(value =>
    /^([1-9]\d*[.,]?\d{0,2})?$/.test(value)
  );

  // Restrict input to numeric values (max 2 decimal places) by using a regular expression filter.
  $('.js-alpha-numeric-spaces-only').inputFilter(value =>
    /^([0-9a-zA-Z ]*)$/.test(value)
  );

  // Toggle open/close mobile nav
  $('.js-open-mobile-nav').click(() => {
    $('.js-mobile-header').addClass('header__mobile--visible');
  });
  $('.js-close-mobile-nav').click(() => {
    $('.js-mobile-header').removeClass('header__mobile--visible');
  });

  $('.ffl-wrapper').floatingFormLabels({
    formElements: 'input, textarea, select'
  });

  // Remove error class on form input after accessing the field
  $(document).on('blur', '.has-error .form-control', function() {
    $(this)
      .parent()
      .removeClass('has-error');
  });

  $.fn.addSortWidget = function(options) {
    const defaults = {
      img_asc: '/images/asc_sort.gif',
      img_desc: '/images/desc_sort.gif',
      img_nosort: '/images/no_sort.gif'
    };

    var options = $.extend({}, defaults, options);
    const $destElement = $(this);
    let is_asc = true;

    $('th', $destElement).each(function(index) {
      // to each header cell (index is useful while sorting)
      $('<img>') // create image that allows you to sort by specific column
        .attr('src', options.img_nosort)
        .addClass('sorttable_img')
        .css({
          cursor: 'pointer',
          'margin-left': '5px'
        })
        .on('click', function() {
          $('.sorttable_img', $destElement).attr('src', options.img_nosort);
          $(this).attr('src', is_asc ? options.img_desc : options.img_asc);
          is_asc = !is_asc;

          const rows = $('tr', $destElement)
            .not(':has(th)')
            .get(); // save all rows (tr) into array (.get())
          rows.sort((a, b) => {
            // sort array with table rows
            let m;
            let n;
            if (
              typeof $(`td:eq(${index})`, a).attr('data-order') !== 'undefined'
            ) {
              m = $(`td:eq(${index})`, a).attr('data-order'); // get column you needed by using index of th element (closure)
              n = $(`td:eq(${index})`, b).attr('data-order');
            } else {
              m = $(`td:eq(${index})`, a).text(); // get column you needed by using index of th element (closure)
              n = $(`td:eq(${index})`, b).text();
            }

            // if elements are numbers
            if (!isNaN(m) && !isNaN(n)) {
              return is_asc ? m - n : n - m;
            }

            // if elements are strings
            if (is_asc) return m.localeCompare(n);
            // asc
            return n.localeCompare(m); // desc
          });

          const tbody = $destElement.has('tbody') ? 'tbody' : ''; // check if table has tbody
          for (let i = 0; i < rows.length; i++) {
            $(tbody, $destElement).append(rows[i]); // add each row to table (elements do not duplicate, just place to new position)
          }
        })
        .appendTo(this); // add created sort image with click event handler to current th element
    });

    return $destElement;
  };

  // Ajax Pagination

  // Update search term in all search fields when one is updated
  $('input[name="search_term"]').on('keyup change', function() {
    const value = $(this).val();
    $('input[name="search_term"]').each(function() {
      $(this).val(value);
    });
  });

  $('#resetFormData').click(() => {
    $('#sort_filter')[0].reset();
    const rootUrl = $('#root-url').val();
    const url = `${SITE_URL + rootUrl}/sort`;
    getData(url);
  });

  // Suppliers suggestion engine on view page
  // uses typeahead.js and bloodhound.js
  // BEGIN::Suggestion engine
  // @TODO: make use of auth:api api guard, currently not working
  const suppliers = new Bloodhound({
    datumTokenizer: function(datum) {
      return Bloodhound.tokenizers.whitespace(datum.value);
    },
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
      wildcard: '%QUERY',
      url: `/application/suppliers`,
      prepare: function (query, settings) {
        settings.url = settings.url + '?term=' + query;
        settings.headers = {
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + $('meta[name="csrf-token"]').attr('content')
        };

        return settings;
      },
      transform: function(response) {
        // Map the remote source JSON array to a JavaScript object array
        return $.map(response.data, function(suppliers) {
          return {
            id: suppliers.id,
            fullName: suppliers.fullName,
            email: suppliers.email,
            supplier: suppliers.supplier,
            fullNameSupplier: suppliers.fullNameSupplier,
          };
        });
      },
    },
  });

  // Instantiate the Typeahead UI
  const jsTypeAheadElem = $('.js-typeahead');
  jsTypeAheadElem.typeahead({
    hint: true,
    highlight: true,
    minLength: 1,
  }, {
    display: `fullNameSupplier`,
    source: suppliers,
    limit: 10,
    templates: {
      empty: [
        '<div class="list-group search-results-dropdown"><div class="list-group-item">Nothing found.</div></div>',
      ],
      header: [
        '<div class="mt-2 mb-2">',
      ],
      suggestion: function(data) {
        // the key from the array we want to display (name,id,email,etc...)
        return '' +
          '<div class="suppliers-suggestion-engine p-2">' +
          `<a href="#" class="suggested-supplier" data-id="${data.id}">${data.fullNameSupplier}</a>` +
          '</div>';
      },
    },
  });

  // submit and save form data to api endpoint
  jsTypeAheadElem.bind('typeahead:select', function(event, suggestion) {
    const formData = new FormData();
    formData.append('supplierId', suggestion.id);
    formData.append('fullName', suggestion.fullName);
    formData.append('email', suggestion.email);
    formData.append('uuid', $('.js-uuid').val());
    window.httpPost(
      '/application/suppliers/update/',
      formData,
      {},
      false,
      false
    );
  });

  // clear text field on focus
  jsTypeAheadElem.on('click', function() {
    $(this).val('');
  }); // END::Suggestion engine

  $('.js-rate-brackets').select2({
    width: '100%',
    matcher: createSelect2CharactersMatcher()
  });

  $('.js-export-repayments').on('click', async function () {
    const rateBracket = $('.js-export-repayments').parent().find('.rate-brackets :selected').val();

    if (!rateBracket) {
      return alert('Please select rate bracket');
    }

    window.open('/calculator/repayments/' + rateBracket);
  });
});

$(document).on('click', '#pagination a', function(ev) {
  ev.preventDefault();
  const url = $(this).attr('href');
  getData(url);
});

const sortingForm = $('#sort_filter');

// Search/filter form submission
sortingForm.on('submit', function(e) {
  e.preventDefault();
  getData($(this).attr('action'));
});

// Pressing the 'escape' key on the search field clears the search form and submits the form
sortingForm.on('keyup keypress', function(e) {
  const keyCode = e.keyCode || e.which;
  if (keyCode === 27) {
    $(this).reset();
    getData($(this).attr('action'));
  }
});

window.setupDatatable = (
  cls = '.js-datatable',
  order = 'desc',
  orderColumn = 1,
  options = {}
) => {
  if ($.fn.dataTable.isDataTable(cls)) {
    const table = $(cls).DataTable();
    table.rows().invalidate();
  } else {
    const optionsDataTable = $.extend({
      columnDefs: [
        {
          orderable: false,
          targets: [-1, 'no-sort']
        }
      ],
      lengthChange: false,
      order: [[orderColumn, order]],
      pageLength: 20,
      searching: false,
      info: false
    }, options);
    $(cls).DataTable(optionsDataTable);
  }
};

// This is placeholder for custom logic on redirecting to be reused across screens
window.redirect = url => {
  location.href = url
}

window.toggleVisibility = (property, value) => {
  $(`[data-visible^="${property}="]`).addClass('hidden');
  $(`[data-visible="${property}=${value}"]`).removeClass('hidden');

  $(`[data-visible^="${property}:"]`).addClass('hidden');
  if (!value) return; // Disallow matching empty values in list
  const valueSearchRegex = new RegExp(`\\b${value}\\b`);
  $(`[data-visible^="${property}:"]`).each(function () {
    const values = $(this).data('visible').split(':')[1];

    if (valueSearchRegex.test(values)) {
      $(this).removeClass('hidden');
    }
  });
};

window.createSelect2CharactersMatcher = () => {
  let currentTerm
  let currentSearchRegex

  return (search, data) => {
    if (!search || $.trim(search.term) === '') {
      return data;
    }

    const term = search.term
    if (!currentSearchRegex || currentTerm !== term) {
      currentTerm = term

      const matchAllChar = '.*';
      const searchPattern = [
        matchAllChar,
        currentTerm.split('')
          .map(char => char.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')) // escape regex chars
          .join('.*'),
        matchAllChar,
      ].join('');
      currentSearchRegex = new RegExp(searchPattern, 'i');
    }

    if (data.element.tagName !== 'OPTGROUP') {
      return currentSearchRegex.test(data.text) ? data : null;
    }

    if (!data.children || !data.children.length) {
      return null;
    }

    const filteredChildren = data.children.filter(item => currentSearchRegex.test(item.text))

    if (filteredChildren.length) {
      return Object.assign({}, data, {
        children: filteredChildren
      });
    } else {
      return null;
    }
  };
};

export function getGoogleMapsAutoComplete(input) {
  return new google.maps.places.Autocomplete(input, {
    componentRestrictions: {
      country: 'au'
    },
    types: ['address']
  });
}

// Multiple Google Maps - Address
export function addressInput() {
  $('.address-input').each(function (idx, address) {
    const autocomplete = getGoogleMapsAutoComplete($(this)[0]);
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
    });
  });
}

/**
 * It takes an array of objects, and returns an array of objects with the value property converted to a
 * number
 * @param data - The data that you want to convert.
 */
export function convertCurrencyInSerializeArray(data) {
  return data.map(function (item) {
    let value = item.value
    if(typeof value === 'string' || value instanceof String) {
      const formatToNumber = Number(value.replace(/[^0-9\.]+/g, ""));
      const currencyFormat = new Intl.NumberFormat('en-US').format(formatToNumber)
      const isValid = value === currencyFormat;
      if (isValid) {
        value = formatToNumber
      }
    }
    return {
      name: item.name,
      value: value
    }
  })
}

export function getEndPointApplication() {
  const applicationType = parseInt($('#application_type').val());
  switch (applicationType) {
    case APPLICATION_RESIDENTIAL:
      return 'applications-residential';
    case APPLICATION_CAR:
      return 'applications-car';
    case APPLICATION_SUPPLIER_ACCREDITATION:
      return 'supplier-accreditation';
    case APPLICATION_STOCK_FINANCE:
      return 'stock-finance';
    default:
      return 'applications';
  }
}

export function saveApplication(data, callbacks) {
  $('.js-loading').show();
  const dataForm = convertCurrencyInSerializeArray(data);
  let endPoint = getEndPointApplication();
  endPoint = `/${endPoint}/save`;

  if (!window.grecaptcha || !window.GOOGLE_RECAPTCHA_KEY) {
    return notifyBox('Error', 'No application verification available, please reload the page and try again. If the issue persists, please contact support for further assistance.', 'error');
  }

  function executeRecaptchaWithTimeout(key, action, timeoutMs = 10000) {
    return Promise.race([
      grecaptcha.execute(key, { action }),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error('reCAPTCHA timeout')), timeoutMs)
      )
    ]);
  }

  async function getRecaptchaTokenWithRetries(key, action, maxRetries = 3, timeoutMs = 10000) {
    let lastError;
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const token = await executeRecaptchaWithTimeout(key, action, timeoutMs);
        return token;
      } catch (err) {
        lastError = err;
        console.warn(`reCAPTCHA attempt ${attempt} failed:`, err.message);
        if (attempt < maxRetries) {
          await new Promise(res => setTimeout(res, 1000 * attempt));
        }
      }
    }
    throw lastError;
  }

  return new Promise((resolve, reject) => {
    grecaptcha.ready(async function () {
      try {
        const token = await getRecaptchaTokenWithRetries(GOOGLE_RECAPTCHA_KEY, 'save_application', 3, 10000);
        resolve(window.httpPost(
          endPoint,
          typeof dataForm === 'string'
            ? dataForm + '&g-recaptcha-response=' + token
            : dataForm.concat([
              {
                name: 'g-recaptcha-response',
                value: token
              }
            ]),
          callbacks
        ));
      } catch (error) {
        $('.js-loading').hide();
        notifyBox('Error', 'reCAPTCHA failed after several attempts. Please try again later.', 'error');
        console.error('Final reCAPTCHA error:', error);
        reject(error);
      }
    });
  });
}

/**
 * It takes a jQuery object as an argument, gets the value of the object, removes all commas from the
 * value, and then formats the value as a currency
 * @param  - The input element that you want to convert.
 */
function convertInputToCurrency($input) {
  let value = $input.val()
  if(value) {
    value = value.replaceAll(',', '');
    $input.val(new Intl.NumberFormat('en-US').format(value));
  }
}

/**
  The above code is a function that is used to convert a number to a currency format. 
  */
$(document).on('keypress , change', '.js-number-separator', function (e) {
  if (/^-?\d*[,.]?(\d{0,3},)*(\d{3},)?\d{0,3}$/.test(e.key)) {
    $('.js-number-separator').on('input', function () {
      convertInputToCurrency($(this))
    });
  } else {
    e.preventDefault();
    return false;
  }
});

/**
 Converting the input to currency. 
 */
$('.js-number-separator').each(function () {
  convertInputToCurrency($(this))
})

export function bindDobInputs() {
  $('.js-dob').each(function (i) {
    const $dob = $(this);
    const $dobInput = $dob.find('.js-dob-input');

    // Preset DOB inputs
    const $dobVal = $dobInput.val();
    if ($dobVal.length) {
      const dobVal = $dobVal.split('-');

      // date of birth day
      $dob
        .find('.js-dob-date')
        .val(dobVal[0])
        .trigger('change');
      $dob.find('.js-dob-date').attr('value', dobVal[0]);

      // date of birth month
      $dob
        .find('.js-dob-month')
        .val(dobVal[1])
        .trigger('change');
      $dob
        .find(`.js-dob-month option[value=${dobVal[1]}]`)
        .attr('selected', 'selected');

      // date of birth year
      $dob
        .find('.js-dob-year')
        .val(dobVal[2])
        .trigger('change');
      $dob.find('.js-dob-year').attr('value', dobVal[2]);
    }

    // Whenever any of the DOB form elements change, re-populate the
    // date of birth (dob) hidden field
    $dob.find('.js-dob-inputs').on('change', 'input, select', e => {
      const $inputs = $(e.delegateTarget);
      const date = $inputs.find('.js-dob-date').val();
      const month = $inputs.find('.js-dob-month').val();
      const year = $inputs.find('.js-dob-year').val();

      $dobInput.val(`${date}-${month}-${year}`);
    });
  });
}

export function displayErrorMessage($context, errors) {
  const $form = $context.closest('form');
  $form.find('.js-display-errors').html('')
  const individualError = Object.keys(errors).find(error => error === 'individual_id' || error.includes('individual_id'))
  if (individualError) {
    notifyBox('Error', 'Individual information must be completed before this information.', 'error');
    return false;
  }
  notifyBox('Error', 'The given data was invalid.', 'error');

  for (const key in errors) {
    if (Object.hasOwnProperty.call(errors, key)) {
      const index = key.replaceAll('.', '_') + '-err';
      const $errorElement = $form.find(`.${index}`);
      $errorElement.html(errors[key][0]);
      $errorElement.show();
    }
  }
}

export function initializeDataTableServer($table, url, columns, columnDefs = []) {
  if ($.fn.dataTable.isDataTable($table)) {
    $table.DataTable().destroy();
  }

  return $table.DataTable({
    serverSide: true,
    ajax: {
      url: url
    },
    ordering: false,
    pageLength: 20,
    columnDefs: columnDefs,
    lengthChange: false,
    searching: false,
    info: false,
    columns: columns
  });
}

export function handleAddEventSmartlook(eventName, applicationType = null, startTime = null) {
  if (!window.smartlook) return;
  let titleEvent = 'Commercial'

  const properties = startTime
    ? { durationInSeconds: (Date.now() - startTime) / 1000 }
    : {};
  if (applicationType) {
    switch (parseInt(applicationType)) {
      case APPLICATION_RESIDENTIAL:
        titleEvent = 'Residential: '
        break;
      case APPLICATION_CAR:
        titleEvent = 'Car: '
        break;
      case APPLICATION_SUPPLIER_ACCREDITATION:
        titleEvent = 'Supplier accreditation: '
        break;
      default:
        titleEvent = 'Commercial'
        break;
    }
  }

  eventName = titleEvent + eventName;

  window.smartlook('track', eventName, properties);
}
